import React , {useState} from 'react';
import emailjs from 'emailjs-com';
import { useTranslation } from "react-i18next";

const Result = () => {
    const { t } = useTranslation('enterprise');
    return (
        <p className="success-message">{t("contact.returnReceipt")}</p>
    )
}

function ContactForm({props , formStyle, btnClass}) {
    const { t } = useTranslation('enterprise');
    const [ result,showresult ] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
        .sendForm(
            'service_g6nkdzh', 
            'template_v7gpden', 
            e.target, 
            'user_AC39woxErrrF3XaKjroeQ'
        )
        .then((result) => {
            console.log(result.text);
            }, 
            (error) => {
                console.log(error.text);
            }
        );
        e.target.reset();
        showresult(true);
    };

    setTimeout(() => {
        showresult(false);
    }, 5000);

    return (
        <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
            <div className="form-group">
                <input 
                type="text"
                name="from_name"
                placeholder={t("contact.fullName")}
                required
                />
            </div>

            <div className="form-group">
                <input 
                type="email"
                name="reply_to"
                placeholder={t("contact.email")}
                required
                />
            </div>

            <div className="form-group">
                <input 
                type="text"
                name="company"
                placeholder={t("contact.company")}
                required
                />
            </div>

            <div className="form-group">
                <textarea 
                name="message"
                placeholder={t("contact.message")}
                required
                >
                </textarea>
            </div>

            <div className="form-group">
                <button className={`btn-default btn-large ${btnClass}`}>{t("contact.send")}</button>
            </div> 

            <div className="form-group">
                {result ? <Result /> : null}
            </div> 
        </form>
    )
}
export default ContactForm;
